<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <el-alert
      type="warning"
      :closable="false"
      show-icon
      title="用户已付运费且订单在待取件，但快递公司自动预约已失败或仍在重试。可查看详情后重新入队预约，或标记人工已处理。"
      style="margin-bottom: 12px"
    />

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">父订单号：</span>
          <el-input v-model="query.fatherOrderNo" clearable placeholder="模糊" style="width: 180px" @keyup.enter.native="searchFn" />
        </div>
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">用户ID：</span>
          <el-input v-model="query.userIdStr" clearable placeholder="精确" style="width: 120px" @keyup.enter.native="searchFn" />
        </div>
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">状态：</span>
          <el-select v-model="query.bookingStatus" style="width: 140px">
            <el-option label="预约失败" value="FAILED" />
            <el-option label="待预约/重试中" value="ALL" />
          </el-select>
        </div>
        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <div class="table-scroll-wrap">
      <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
        <el-table-column prop="fatherOrderNo" label="父订单号" min-width="170" show-overflow-tooltip />
        <el-table-column prop="bizLabel" label="类型" width="72" align="center" />
        <el-table-column prop="childOrderNo" label="子订单号" min-width="150" show-overflow-tooltip />
        <el-table-column prop="userId" label="用户ID" width="90" align="center" />
        <el-table-column prop="bookingStatus" label="预约状态" width="100" align="center" />
        <el-table-column prop="bookingAttempts" label="尝试次数" width="88" align="center" />
        <el-table-column label="预付运费" width="90" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.pickupFreightAmount) }}</template>
        </el-table-column>
        <el-table-column prop="yysj" label="预约时间" min-width="160" show-overflow-tooltip />
        <el-table-column prop="lastError" label="最近失败原因" min-width="200" show-overflow-tooltip />
        <el-table-column label="失败时间" width="168" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.failedAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="retryBooking(scope.row)">重新预约</el-button>
            <el-button type="text" size="small" @click="markManual(scope.row)">人工已处理</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />

    <el-dialog title="预约寄件详情" :visible.sync="detailVisible" width="720px">
      <div v-if="detail" class="detail-box">
        <p><b>父订单号：</b>{{ detail.fatherOrderNo }}</p>
        <p><b>子订单号：</b>{{ detail.childOrderNo || "-" }}</p>
        <p><b>类型：</b>{{ detail.bizLabel }}</p>
        <p><b>用户ID：</b>{{ detail.userId }}</p>
        <p><b>预约状态：</b>{{ detail.bookingStatus }}（尝试 {{ detail.bookingAttempts || 0 }} 次）</p>
        <p><b>预付运费：</b>{{ formatMoney(detail.pickupFreightAmount) }}</p>
        <p><b>预约时间：</b>{{ detail.yysj || "-" }}</p>
        <p><b>最近失败：</b>{{ detail.lastError || "-" }}</p>
        <p><b>取件地址：</b>{{ detail.qjdz || "-" }}</p>
        <p><b>预约参数：</b></p>
        <pre class="json-pre">{{ detail.pickupSnapshot || "-" }}</pre>
        <p v-if="detail.pickupOrderId"><b>寄件单：</b>{{ detail.pickupNo }}（ID {{ detail.pickupOrderId }}）</p>
        <p v-if="detail.manualNote"><b>人工备注：</b>{{ detail.manualNote }}</p>
      </div>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button type="primary" @click="retryBooking(detail)">重新入队预约</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  name: "PickupBookingFailList",
  data() {
    return {
      historyArr: ["客诉处理", "上门预约失败"],
      loading: false,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      pageSize: 20,
      query: {
        fatherOrderNo: "",
        userIdStr: "",
        bookingStatus: "FAILED"
      },
      detailVisible: false,
      detail: null
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    formatMoney(v) {
      if (v == null || v === "") return "-";
      return Number(v).toFixed(2);
    },
    buildPayload() {
      const payload = {
        page: this.currentPage,
        size: this.pageSize,
        fatherOrderNo: this.query.fatherOrderNo || undefined,
        bookingStatus: this.query.bookingStatus || "FAILED"
      };
      if (this.query.userIdStr) {
        payload.userId = Number(this.query.userIdStr);
      }
      return payload;
    },
    fetchList(page) {
      if (page) this.currentPage = page;
      this.loading = true;
      this.$post(this.$api.mgmtPickupBookingFailList, this.buildPayload(), "POST")
        .then((res) => {
          const body = res.data || {};
          if (body.code === 200) {
            this.tableData = body.data || [];
            this.tableTotal = body.size != null ? body.size : 0;
          } else {
            this.$message.error(body.msg || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchFn() {
      this.fetchList(1);
    },
    resetFn() {
      this.query = { fatherOrderNo: "", userIdStr: "", bookingStatus: "FAILED" };
      this.fetchList(1);
    },
    changePage(p) {
      this.fetchList(p);
    },
    handlePageSizeChange() {
      this.fetchList(1);
    },
    openDetail(row) {
      if (!row || !row.fatherOrderId) return;
      this.$get(this.$api.mgmtPickupBookingFailDetail, { fatherOrderId: row.fatherOrderId }).then((res) => {
        const body = res.data || {};
        if (body.code === 200) {
          this.detail = body.data;
          this.detailVisible = true;
        } else {
          this.$message.error(body.msg || "加载失败");
        }
      });
    },
    retryBooking(row) {
      const id = row && row.fatherOrderId;
      if (!id) return;
      this.$post(this.$api.mgmtPickupBookingFailRetry, { fatherOrderId: id }, "POST").then((res) => {
        const body = res.data || {};
        if (body.code === 200) {
          this.$message.success(body.msg || "已重新入队");
          this.detailVisible = false;
          this.fetchList(this.currentPage);
        } else {
          this.$message.error(body.msg || "操作失败");
        }
      });
    },
    markManual(row) {
      const id = row && row.fatherOrderId;
      if (!id) return;
      this.$prompt("人工处理备注（可选）", "标记人工已处理", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "如：已电话协助用户改约"
      })
        .then(({ value }) => {
          return this.$post(
            this.$api.mgmtPickupBookingFailMarkManual,
            { fatherOrderId: id, manualNote: value || "" },
            "POST"
          );
        })
        .then((res) => {
          if (!res) return;
          const body = res.data || {};
          if (body.code === 200) {
            this.$message.success("已标记");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error(body.msg || "操作失败");
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.detail-box p {
  margin: 8px 0;
  line-height: 1.6;
  word-break: break-all;
}
.json-pre {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  max-height: 200px;
  overflow: auto;
  font-size: 12px;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/pickupBookingFail/index.vue